import { push } from 'redux-first-history';
import { all, fork, put, takeLatest } from 'redux-saga/effects';
import { isNull } from 'lodash/fp';

import { setSelectedTab } from './actions';
import { DataManagementTile, DoraDataManagementActionTypes } from './types';
import { DoraMyCompaniesView } from '../../my-companies/store/types';
import { toggleDoraMyCompaniesView } from '../../my-companies/store/actions';
import { DoraThirdPartyView } from '../../third-party-companies/store/types';
import { changeThirdPartyView } from '../../third-party-companies/store/actions';

export const doraPathnames = {
    [DataManagementTile.MY_COMPANIES]: 'companies',
    [DataManagementTile.FUNCTIONS_PERFORMED]: 'functions',
    [DataManagementTile.SUPPLY_CHAIN]: 'supply-chain',
    [DataManagementTile.RELEVANT_THIRD_PARTY_COMPANIES]: 'third-party-companies'
};

export function* redirectSelectedTab({ payload }: ReturnType<typeof setSelectedTab>) {
    const { reroute, selectedTab } = payload;
    if (!isNull(selectedTab) && reroute) {
        if (selectedTab === DataManagementTile.MY_COMPANIES) {
            yield put(toggleDoraMyCompaniesView(DoraMyCompaniesView.IN_SCOPE));
        } else if (selectedTab === DataManagementTile.RELEVANT_THIRD_PARTY_COMPANIES) {
            yield put(changeThirdPartyView(DoraThirdPartyView.ACTIVE_THIRD_PARTIES));
        } else {
            const extension = doraPathnames[selectedTab];
            const navigationPath = `/dora/data-management/${extension}`;
            yield put(push(navigationPath));
        }
    }
}

function* redirectSelectedTabWatcher() {
    yield takeLatest(DoraDataManagementActionTypes.SET_SELECTED_DORA_MANAGEMENT_TAB, redirectSelectedTab);
}

export function* doraDataManagementSaga() {
    yield all([
        fork(redirectSelectedTabWatcher)
    ]);
}
